import Vue from 'vue';
import Swiper, { Pagination, Navigation } from 'swiper';

Swiper.use([Pagination, Navigation]);

Vue.component('reviews-component', {
    data() {
        return {
            swiper: null,
            sliderHolder: null,
        };
    },

    mounted() {
        this.sliderHolder = this.$el.querySelector('.reviews__container');

        this.initSwiper();
    },

    methods: {
        initSwiper() {
            this.swiper = new Swiper(this.sliderHolder, {
                modules: [Pagination],
                // Optional parameters
                direction: 'horizontal',
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                navigation: {
                    nextEl: ".block-reviews__nav-right",
                    prevEl: ".block-reviews__nav-left",
                },
                slidesPerView: 1,
                spaceBetween: 20,
            });
        },
    },
});